import axios from "axios"
import { IAdelantarRequest, IDisponibleRequest } from "../models/dataDisponible";

export const getCuits = async () => {
    return axios.get('api/Reembolso/GetCuits')
}

export const getCallBack_parametros = async () => {
    return axios.get('api/Reembolso/Parametros')
}

export const postDisponiblesPorCuit = async (postData: IDisponibleRequest) => {
    return axios.post('api/Reembolso/PostDisponiblesPorCuit',postData)
}

export const postAdelantar = async (postData: IAdelantarRequest) => {
    return axios.post('api/Reembolso/Adelantar',postData)
}
